import { useContext } from "react";
import { PageNewState, AddCmpProjectDialogContext } from ".";

export const useAddCmpProjectDialogState = () => {
  const { pageState, setPageState } = useContext(AddCmpProjectDialogContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
